
import dropdownState, { cancelCloseDropdown, scheduleCloseDropdown } from './nav-dropdown-state'
import { getMenuItems } from './nav-items'

export default {
  name: 'NavMegaMenu',
  data() {
    return {
      dropdownState,
      arrowLeftPx: 0
    }
  },
  computed: {
    menuItems() {
      return getMenuItems()
    },
    activeItem() {
      return this.menuItems.find((item) => item.id === this.dropdownState.activeId) || null
    }
  },
  watch: {
    'dropdownState.activeId'() {
      this.$nextTick(this.updateArrowPosition)
    },
    'dropdownState.arrowLeft'() {
      this.updateArrowPosition()
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateArrowPosition)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateArrowPosition)
  },
  methods: {
    updateArrowPosition() {
      if (!this.$el || typeof this.$el.getBoundingClientRect !== 'function') {
        return
      }
      const navMegaRect = this.$el.getBoundingClientRect()
      this.arrowLeftPx = this.dropdownState.arrowLeft - navMegaRect.left
    },
    handleEnter() {
      cancelCloseDropdown()
    },
    handleLeave() {
      scheduleCloseDropdown()
    },
    handleClick() {
      scheduleCloseDropdown(0)
    }
  }
}
